import {Cancel, CheckCircle, TrendingUp} from '@mui/icons-material';
import {Box, Paper, Typography} from '@mui/material';

export interface SessionCompleteBreakdownProps {
  correctAnswers: number;
  incorrectAnswers: number;
  totalQuestions: number;
}

export default function SessionCompleteBreakdown({
  correctAnswers,
  incorrectAnswers,
  totalQuestions,
}: SessionCompleteBreakdownProps) {
  return (
    <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', md: 'repeat(3, 1fr)'}, gap: 3}}>
      <Paper sx={{p: 3, textAlign: 'center'}} data-testid="correct-answers-card">
        <CheckCircle sx={{fontSize: 40, color: 'success.main', mb: 1}} />
        <Typography
          variant="h4"
          sx={{fontWeight: 700, color: 'success.main', mb: 1}}
          data-testid="correct-answers-count"
        >
          {correctAnswers}
        </Typography>
        <Typography variant="body1">Correct Answers</Typography>
      </Paper>

      <Paper sx={{p: 3, textAlign: 'center'}} data-testid="incorrect-answers-card">
        <Cancel sx={{fontSize: 40, color: 'error.main', mb: 1}} />
        <Typography
          variant="h4"
          sx={{fontWeight: 700, color: 'error.main', mb: 1}}
          data-testid="incorrect-answers-count"
        >
          {incorrectAnswers}
        </Typography>
        <Typography variant="body1">Incorrect Answers</Typography>
      </Paper>

      <Paper sx={{p: 3, textAlign: 'center'}} data-testid="total-questions-card">
        <TrendingUp sx={{fontSize: 40, color: 'primary.main', mb: 1}} />
        <Typography
          variant="h4"
          sx={{fontWeight: 700, color: 'primary.main', mb: 1}}
          data-testid="total-questions-count"
        >
          {totalQuestions}
        </Typography>
        <Typography variant="body1">Total Questions</Typography>
      </Paper>
    </Box>
  );
}
